import { Flex } from 'antd';
import React from 'react';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BrandLogo: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Flex
      align="center"
      gap={10}
      onClick={() => navigate('/')}
      style={{
        cursor: 'pointer',
      }}
    >
      <img src="/assets/logo.svg" alt="Logo" />
      <img src="/assets/logo-text.svg" alt="Logo" style={{ width: '150px' }} />
    </Flex>
  );
};

export default BrandLogo;
